export enum ProfileCardSizeEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
